import { jsx as _jsx } from "react/jsx-runtime";
export default function Container(props) {
    return (_jsx("div", { className: "container mx-auto px-4 md:px-24 xl:px-32", children: props.children }));
}
